
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, onMounted, defineComponent} from 'vue';
import {useActivityStore} from '../../stores/ActivityStore';
import {storeToRefs} from 'pinia'
import LoadingSpinner from "../../components/loading/LoadingSpinner.vue";
import {ActivityDateListStruct} from "../../utils/structs";
import {
    addParamsToUrl,
    assertData,
    fetcher
} from "../../utils/utils";
import {getActivityBaseConfig} from "../../utils/config-helper";
import NumberSpinner from "../../components/form-elements/NumberSpinner.vue";
import DateListConfigurations from "../../components/configurations/DateListConfigurations.vue";

export default defineComponent({
    name: 'DateListView',
    components: {
        NumberSpinner,
        LoadingSpinner,
        DateListConfigurations,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        activityId: {
            type: String,
            required: true,
        }
    },
    setup(props) {
        const activityStore = useActivityStore();
        const {
            step,
            selectedDateStart,
            selectedDateEnd,
            selectedPriceGroup,
            selectedCurrency,
            allPriceGroups,
            ticketConfigurations
        } = storeToRefs(activityStore);

        const {
            changeStep,
            changePriceGroup,
            changeTicketConfigurations,
            changeAllPriceGroups,
            changeFinalPrice,
            changeConfigurations
        } = activityStore;

        const dateList = ref<object>([]);
        const isLoading = ref<boolean>(true);
        const priceGroups = ref<object>([]);
        const finalConfigurations = ref<object>([]);
        const isMobile = matchMedia('(max-width: 767px)').matches;

        const onChangeStep = (step: number) => {
            changeStep(step);
        }

        const onChangePriceGroupCounter = (counter: number, item: Object, dateListItem : Object) => {
            let ticketConfig = ticketConfigurations.value;
            let priceGroup = item.id;
            let dateString = dateListItem?.date;

            ticketConfig['priceGroupsPerDate'][dateString][priceGroup].counter = counter;
            ticketConfig['priceGroupsPerDate'][dateString][priceGroup].price = item.price;

            changeTicketConfigurations(ticketConfig);
            finalConfigurations.value = getConfigurations();
            changeConfigurations(getConfigurations());
            calculatePrice();
        }

        const fetchPrices = async () => {

            const params = {
                activityId: props.activityId,
                ...(selectedDateStart.value !== "" && {selectedDateStart: selectedDateStart.value}),
                ...(selectedDateEnd.value !== "" && {selectedDateEnd: selectedDateEnd.value}),
            };

            let url = getActivityBaseConfig().dateList;
            url = addParamsToUrl(url, new URLSearchParams(params));
            await fetcher(url).then((result) => {
                assertData(result, ActivityDateListStruct, url, 'fetchPrices', 'danger');

                result.priceGroups.forEach(function (element, index) {
                    priceGroups.value.push({
                        label: element.label,
                        labelPlural: element.labelPlural,
                        value: element.id
                    })
                });

                dateList.value = result.dateList;

                changeAllPriceGroups(priceGroups.value);

                if (!selectedPriceGroup.value) {
                    changePriceGroup(priceGroups.value[0].value);
                }
                isLoading.value = false;

                let ticketConfig = ticketConfigurations.value;

                allPriceGroups.value.forEach((priceGroup) => {
                    dateList.value.forEach((dateListItem) => {
                        if (ticketConfig['priceGroupsPerDate'][dateListItem.date] === undefined) {
                            ticketConfig['priceGroupsPerDate'][dateListItem.date] = {};
                        }
                        ticketConfig['priceGroupsPerDate'][dateListItem.date][priceGroup.value] = {};
                        ticketConfig['priceGroupsPerDate'][dateListItem.date][priceGroup.value].counter = 0;
                        ticketConfig['priceGroupsPerDate'][dateListItem.date][priceGroup.value].date = dateListItem.date;
                    });
                });

                changeTicketConfigurations(ticketConfig);
                calculatePrice();
            }).catch((error) => {
                console.log(error);
            });
        };

        onMounted(() => {
            fetchPrices();
            finalConfigurations.value = getConfigurations();
            changeConfigurations(getConfigurations());
        });

        const calculatePrice = () => {
            let ticketConfig = ticketConfigurations.value;
            let total = 0;

            allPriceGroups.value.forEach(function (priceGroup) {
                Object.keys(ticketConfig['priceGroupsPerDate']).map((item) => {
                     if (ticketConfig['priceGroupsPerDate'][item][priceGroup.value]?.counter) {
                         total += getPriceGroupSum(ticketConfig['priceGroupsPerDate'][item][priceGroup.value].price.price, ticketConfig['priceGroupsPerDate'][item][priceGroup.value]?.counter);
                     }
                });
            })
            ticketConfig['totalPrice'] = total;
            changeFinalPrice(total);
        }

        const getPriceGroupSum = (price: Number, priceGroupCounter: Number) => {
            return price * priceGroupCounter;
        }

        const getConfigurations = () => {
            let ticketConfig = ticketConfigurations.value;
            let finalConfig = [];
            allPriceGroups.value.forEach(function (priceGroup) {
                Object.keys(ticketConfig['priceGroupsPerDate']).map((item, key) => {
                    let priceGroupItem = ticketConfig['priceGroupsPerDate'][item][priceGroup.value];
                    if(priceGroupItem.counter > 0) {
                       finalConfig.push({
                           amount:  priceGroupItem.counter,
                           priceGroup: priceGroup.value,
                           selectedDate:  priceGroupItem.date
                       });
                    }
                });
            });
            return finalConfig;
        }

        return {
            step,
            selectedDateStart,
            selectedDateEnd,
            changeStep,
            onChangeStep,
            priceGroups,
            selectedPriceGroup,
            allPriceGroups,
            onChangePriceGroupCounter,
            ticketConfigurations,
            selectedCurrency,
            getConfigurations,
            translate,
            isMobile,
            dateList,
        };
    }
});
